<div class="header">
  <a href='https://assurances-factures-oney.souscription.eu/'><img src="./assets/oney/oney.png" class="img-fluid" /></a>
  <span class="primary-color link" (click)='back()'><strong>< Retour</strong></span>
</div>
